var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Ticker from './Ticker';
import Unit from './Unit';
import Group from './Group';
import InputSuffix, { getVisibleSuffixCount } from './InputSuffix';

import styles from './Input.scss';

var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focus: false
    }, _this.focus = function () {
      _this._onFocus();
      _this.input && _this.input.focus();
    }, _this.blur = function () {
      _this._onBlur();
      _this.input && _this.input.blur();
    }, _this.select = function () {
      _this.input && _this.input.select();
    }, _this._onFocus = function () {
      _this.setState({ focus: true });
      _this.props.onFocus && _this.props.onFocus();

      if (_this.props.autoSelect) {
        // Set timeout is needed here since onFocus is called before react
        // gets the reference for the input (specifically when autoFocus
        // is on. So setTimeout ensures we have the ref.input needed in select)
        setTimeout(function () {
          return _this.select();
        }, 0);
      }
    }, _this._onBlur = function (e) {
      _this.setState({ focus: false });
      _this.props.onBlur && _this.props.onBlur(e);
    }, _this._onClick = function (e) {
      _this.props.onInputClicked && _this.props.onInputClicked(e);
    }, _this._onKeyDown = function (e) {
      _this.props.onKeyDown && _this.props.onKeyDown(e);

      if (e.keyCode === 13 /* enter */) {
          _this.props.onEnterPressed && _this.props.onEnterPressed(e);
        } else if (e.keyCode === 27 /* esc */) {
          _this.props.onEscapePressed && _this.props.onEscapePressed(e);
        }
    }, _this._onChange = function (e) {
      if (_this.props.type === 'number' && !/^[\d.,\-+]*$/.test(e.target.value)) {
        return;
      }

      _this.props.onChange && _this.props.onChange(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Input, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.autoFocus && this._onFocus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _classNames;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props = this.props,
          id = _props.id,
          value = _props.value,
          placeholder = _props.placeholder,
          help = _props.help,
          helpMessage = _props.helpMessage,
          unit = _props.unit,
          magnifyingGlass = _props.magnifyingGlass,
          menuArrow = _props.menuArrow,
          defaultValue = _props.defaultValue,
          tabIndex = _props.tabIndex,
          onClear = _props.onClear,
          autoFocus = _props.autoFocus,
          onKeyUp = _props.onKeyUp,
          onPaste = _props.onPaste,
          readOnly = _props.readOnly,
          prefix = _props.prefix,
          suffix = _props.suffix,
          type = _props.type,
          errorMessage = _props.errorMessage,
          maxLength = _props.maxLength,
          textOverflow = _props.textOverflow,
          theme = _props.theme,
          disabled = _props.disabled,
          error = _props.error,
          width = _props.width,
          tooltipPlacement = _props.tooltipPlacement,
          onTooltipShow = _props.onTooltipShow;


      var onIconClicked = function onIconClicked() {
        if (!disabled) {
          _this2._onFocus();
        }
      };

      var isClearButtonVisible = onClear && !error && !disabled && !!value;

      var visibleSuffixCount = getVisibleSuffixCount({
        error: error, disabled: disabled, help: help, magnifyingGlass: magnifyingGlass, isClearButtonVisible: isClearButtonVisible, menuArrow: menuArrow, unit: unit, suffix: suffix
      });

      var inputClassNames = classNames(styles.input, (_classNames = {}, _defineProperty(_classNames, styles.withPrefix, !!prefix), _defineProperty(_classNames, styles.withSuffix, visibleSuffixCount), _defineProperty(_classNames, styles.withSuffixes, visibleSuffixCount > 1), _classNames));

      var ariaAttribute = {};
      Object.keys(this.props).filter(function (key) {
        return key.startsWith('aria');
      }).map(function (key) {
        return ariaAttribute['aria-' + key.substr(4).toLowerCase()] = _this2.props[key];
      });

      var inputElement = React.createElement('input', _extends({
        style: { textOverflow: textOverflow, width: width },
        ref: function ref(input) {
          return _this2.input = input;
        },
        className: inputClassNames,
        id: id,
        disabled: disabled,
        defaultValue: defaultValue,
        value: value,
        onChange: this._onChange,
        maxLength: maxLength,
        onFocus: this._onFocus,
        onBlur: this._onBlur,
        onKeyDown: this._onKeyDown,
        onDoubleClick: this._onDoubleClick,
        onPaste: onPaste,
        placeholder: placeholder,
        tabIndex: tabIndex,
        autoFocus: autoFocus,
        onClick: this._onClick,
        onKeyUp: onKeyUp,
        readOnly: readOnly,
        type: type
      }, ariaAttribute, props));

      return React.createElement(
        'div',
        { className: styles.inputWrapper },
        prefix && React.createElement(
          'div',
          { className: styles.prefix },
          prefix
        ),
        inputElement,
        visibleSuffixCount > 0 && React.createElement(InputSuffix, {
          error: error,
          errorMessage: errorMessage,
          theme: theme,
          disabled: disabled,
          help: help,
          helpMessage: helpMessage,
          onIconClicked: onIconClicked,
          magnifyingGlass: magnifyingGlass,
          isClearButtonVisible: isClearButtonVisible,
          onClear: onClear,
          menuArrow: menuArrow,
          unit: unit,
          focused: this.state.focus,
          suffix: suffix,
          tooltipPlacement: tooltipPlacement,
          onTooltipShow: onTooltipShow
        })
      );
    }
  }]);

  return Input;
}(Component);

Input.Ticker = Ticker;
Input.Unit = Unit;
Input.Group = Group;


Input.displayName = 'Input';

Input.defaultProps = {
  size: 'normal',
  theme: 'normal',
  errorMessage: '',
  helpMessage: '',
  roundInput: false,
  textOverflow: 'clip',
  maxLength: 524288,
  width: 'initial',
  withSelection: false
};

Input.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  theme: PropTypes.oneOf(['normal', 'paneltitle', 'material', 'amaterial', 'flat', 'flatdark']),
  forceHover: PropTypes.bool,
  forceFocus: PropTypes.bool,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  unit: PropTypes.string,
  defaultValue: PropTypes.string,
  tabIndex: PropTypes.number,
  magnifyingGlass: PropTypes.bool,
  menuArrow: PropTypes.bool,
  rtl: PropTypes.bool,
  autoFocus: PropTypes.bool,
  autoSelect: PropTypes.bool,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onInputClicked: PropTypes.func,
  onEscapePressed: PropTypes.func,
  onEnterPressed: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onPaste: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  dataHook: PropTypes.string,
  size: PropTypes.oneOf(['small', 'normal', 'large']),
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  type: PropTypes.node,
  maxLength: PropTypes.number,
  errorMessage: PropTypes.node,
  roundInput: PropTypes.bool,
  noLeftBorderRadius: PropTypes.string,
  noRightBorderRadius: PropTypes.string,
  help: PropTypes.bool,
  textOverflow: PropTypes.string,
  helpMessage: PropTypes.node,
  title: PropTypes.string,
  width: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaDescribedby: PropTypes.string,
  ariaControls: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  onTooltipShow: PropTypes.func,
  withSelection: PropTypes.bool
};

export default Input;
//# sourceMappingURL=Input.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Input/Input.js